
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M15.111 0H1.89C.85 0 0 .85 0 1.889V15.11C0 16.15.85 17 1.889 17H15.11c1.04 0 1.89-.85 1.89-1.889V1.89C17 .85 16.15 0 15.111 0zm0 15.111H1.89V1.89h13.22v13.22zM12.826 4.326l1.331 1.34-7.555 7.556-3.778-3.768 1.341-1.332 2.437 2.428 6.224-6.224z"}})])
          )
        }
      }
    